import Link from "next/link";

export default function NavigationLinks({ items, className = "" }) {
  return <ul className={className}>{items.map(item => <li key={item.id || item.href}>
    <Link href={item.href}>{item.label}</Link>
    {item.children?.length > 0 && <NavigationLinks items={item.children} className="ml-4 mt-2 space-y-2" />}
  </li>)}</ul>;
}
